import { AlertIcon, Typography } from '@eventbrite/marmalade';
import classnames from 'classnames';
import React, { type FC } from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../../utils/rebrand';
import { RebrandedAlertSvg } from '../../../TimedEntrySeries/assests/RebrandedAlertSvg';
import { MinPriceDisplay } from '../../TimeSlotContainer/MinPriceDisplay/MinPriceDisplay';
import commonStyles from './Header.common.module.scss';
import defaultStyles from './Header.module.scss';
import rebrandStyles from './Header.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

type HeaderProps = {
    error?: boolean;
    errorText?: string;
    icon: React.ReactNode;
    isAppRebrandActive: boolean;
    isExpanded: boolean;
    onClick: () => void;
    text: string;
    title: string;
    sessionMinPrice?: string;
};

const Header: FC<HeaderProps> = ({
    text,
    title,
    icon,
    isExpanded,
    onClick,
    error,
    errorText,
    isAppRebrandActive,
    sessionMinPrice,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];

    const Icon = isAppRebrandActive ? (
        <RebrandedAlertSvg />
    ) : (
        <AlertIcon size="xsmall" />
    );
    return (
        <div
            className={classnames(styles.header, commonStyles.header)}
            onClick={onClick}
            role="button"
        >
            <div
                className={classnames(
                    styles.svgContainer,
                    commonStyles.svgContainer,
                )}
            >
                {icon}
                <Typography
                    className={classnames(styles.headerText, {
                        [styles.expanded]: isExpanded,
                    })}
                >
                    {title}
                </Typography>
            </div>
            <Typography className={styles.selectedText}>{text}</Typography>
            {error && errorText && (
                <div className={styles.error}>
                    {Icon}
                    <Typography
                        variant="body-md-bold"
                        className={styles.errorText}
                    >
                        {errorText}
                    </Typography>
                </div>
            )}
            {sessionMinPrice && (
                <MinPriceDisplay
                    price={sessionMinPrice}
                    containerClassName={commonStyles.minPriceContainer}
                    fromTextClassName={commonStyles.fromText}
                    size="body-md"
                    priceClassName={commonStyles.minPriceText}
                />
            )}
        </div>
    );
};

export default Header;
